import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class AutomationService {

  private baseUrl: any = environment.baseUrl;
  // private baseUrl: any = environment.baseUrl;

  constructor(
    private http: HttpClient,
    private router: Router,
    private commonService: CommonService
  ) { }

  startServer() {
    // alert("AutomationService ---> startServer called")
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/startserver`);
  }

  stopServer(serverport: any) {
    // alert("AutomationService ---> stopServer called")
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/stopserver?serverport=` + serverport);
  }

  stopAppInspector(serverport: any, serial: any, bridgeHost: any) {
    // alert("AutomationService ---> stopServer called")
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/stopAppInspector?` + '&serial=' + serial + '&bridgeHost=' + bridgeHost + '&serverport=' + serverport);
  }

  checkRunningTest(user: any, serialNo: any) {
    // alert("AutomationService ---> stopServer called")
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/checkRunningTest?user=` + user + '&serial=' + serialNo);
  }

  startAppInspector(serialNo: any, userName: any, bridgeHost: any) {
    // alert("AutomationService ---> stopServer called")
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/startAppInspector?serial=` + serialNo + '&bridgeHost=' + bridgeHost + '&userName=' + userName);
  }

  getLogContent(logPath: string): Observable<Blob> {
    const url = `${this.baseUrl}/${logPath}`; // Construct the full URL to fetch the log
    return this.http.get<Blob>(url, { responseType: 'blob' as 'json' });
  }

  // AutomationService.startAppInspector = function (serialNo, userName, bridgeHost) {
  //   let url = '/api/v1/automation/startAppInspector';
  //   let data = {
  //     serialNo : serialNo,
  //     bridgeHost : bridgeHost,
  //   }
  //   // alert("AutomationService ---> stopServer called")
  //   return $http.post(url, data);
  // }


  getAutomationLogs(username) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/getAutomationLogs?username=` + username);
  }

  // AutomationService.downloadLogFile = function (logPath) {
  //   return $http.get('/api/v1/automation/downloadLogFile?logPath=' + logPath)
  // }
  downloadLogFile(logPath?: any, appiumUrl?: any) {
    let dynamicUrl = appiumUrl
    return this.http.get(dynamicUrl + `/downloadLogFile?logPath=` + logPath, { withCredentials: true, responseType: 'text' })




  }

  deleteLog(id: any, logPath: any) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/deleteLog?id=` + id + '&logPath=' + logPath);
  }

  loadDeviceUrl(id: any) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/loadDeviceUrl?id=` + id);
  }

  getAppiumUrl(bridgeHost: any) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/getAppiumUrl?bridgeHost=` + bridgeHost);
  }

  stopRunningAppium(bridgeHost: any, email: any, serial: any) {
    //return $http.get(bridgeHost + '/stopRunningAppium/'+email+'/'+serial)
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/stopRunningAppium?bridgeHost=` + bridgeHost + '&email=' + email + '&serial=' + serial);
  }

  // getCpuInfo(serial: any) {
  //   return this.http.get(`${this.baseUrl}` + `/api/v1/automation/getCpuInfo?serial=` + serial);
  // }

  downloadAsPDF(email: any) {
    return this.http.get(`${this.baseUrl}` + `/file/downloadPdfFiles/` + email + '/screenshot');
    // return $http.post('/api/v1/automation/loadDeviceUrl?id='+id)
  }

  updateDeviceLimit(groupId: any, updateDeviceCount: any) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/users/updateMaxDevicesAllocation/` + groupId + '/' + updateDeviceCount);
  }

  displayOfAccessTokenOfUser(userId: any) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/automation/getAccessToken/` + userId + '/');
  }

  checkDeviceLimitOfgroup(groupId: any, groupName: any) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/users/viewMaximumDeviceCountOfGroup/` + groupId);
  }

  setAppInstaller(email, value) {

    let privilege = value;
    return this.http.get(`${this.baseUrl}` + '/api/v1/users/appInstallationPrivilegeUpdate/' + email + '/' + privilege)
  }
  getBridgeHost(device: any) {
    let deviceinAutomation = device;
    let urlFromDevice = deviceinAutomation.display.url;
    let partsBySlash = urlFromDevice.split("/");
    let hostname2 = partsBySlash[2];
    let location2 = partsBySlash[4];
    let bridgeHost: any;

    if (location2 == null) {
      bridgeHost = "http://localhost:9091/wd/hub";
    } else if (location2 === 'NaviMumbai') {
      bridgeHost = "http://" + hostname2 + "/wd/hub";
    } else {
      bridgeHost = "http://" + location2 + ":9091/wd/hub";
    }
    return bridgeHost;
  }

  downloadSSasPDF(inputStrings: string[], providerUrl: string) {
    const url = providerUrl;

    const formData = new FormData();
    inputStrings.forEach(url => {
      formData.append('inputUrls', url);
    });

    let headers: {
      'Content-Type': undefined,
      'Access-Control-Allow-Origin': '*',
    }
    return this.http.post(url, formData, { headers });
  }

  getPackageName(url: any, serial: any) {
    return this.http.get(url + '/getPackageName/' + serial);
    // return this.http.get('https://proteansaasuat.apmosys.com/bridgetest/wd/hub/getPackageName/RZ8TC00QXCA');

  }


  iosShellCommand(device: any, command: any) {
    let url = device.providerUrl + '/iosShellCommand/' + device.serial;
    let formData = new FormData();
    formData.append('command', command);
    let headers: {
      'Content-Type': undefined
    }
    return this.http.post(url, formData, { headers });
  }

  validationUsersAsPerGroup(groupId: any, deviceSerial: any) {
    this.http.get(`${this.baseUrl}` + `/api/v1/users/validationUsersAsPerGroup/` + groupId).subscribe((res: any) => {
      if (res.success === true || res.success === "true") {
        // window.open('#!/control/' + deviceSerial, "_self");
        this.commonService.setActiveTab('/control/');
        this.router.navigate(['/control', deviceSerial]);
      } else {
        alert('Maximum Devices use Limit reached\nFor more details Contact to Admin');
      }
    });
  }

  validationUsersAsPerGroupMultiDevice(groupId: any) {
    return this.http.get(`${this.baseUrl}` + `/api/v1/users/validationUsersAsPerGroup/` + groupId)
  }

  validationUsersAsPerGroupMaster(groupId: any, deviceSerial: any) {
    this.http.get(`${this.baseUrl}` + `/api/v1/users/validationUsersAsPerGroup/` + groupId).subscribe((res: any) => {
      if (res.success === true || res.success === "true") {
        // window.open('#!/control/' + deviceSerial, "_self");
        this.commonService.setActiveTab('/control/');
        this.router.navigate(['/control', deviceSerial,'slave-selection']);
      } else {
        alert('Maximum Devices use Limit reached\nFor more details Contact to Admin');
      }
    });
  }

}
